import React, { useState, useEffect } from "react";
import ProgramCards from "./programCards";
import cmsApi from "../../services/cmsApi";

const ExplorePrograms = () => {
  const [programsContent, setProgramsContent] = useState({
    title: "",
    description: ""
  });
  const [programCards, setProgramCards] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch programs content from CMS (client-side only)
  useEffect(() => {
    // Only fetch on client side to avoid hydration issues
    if (typeof window === 'undefined') return;
    
    const fetchProgramsContent = async () => {
      try {
        setLoading(true);
        setError("");
        const result = await cmsApi.getHomepageComponentByType('programs');
        if (result.success && result.components.length > 0) {
          const programs = result.components[0];
          setProgramsContent({
            title: programs.title || "",
            description: programs.subtitle || programs.content || ""
          });
          
          // Extract program cards from settings
          // The API will always return default cards if none exist in DB
          if (programs.settings && programs.settings.programCards && Array.isArray(programs.settings.programCards) && programs.settings.programCards.length > 0) {
            // Transform the cards to match the expected format
            const transformedCards = programs.settings.programCards.map((card, index) => ({
              id: card.id || index + 1,
              image: card.image || '',
              heading: card.heading || '',
              introduction: card.introduction || '',
              buttonText: card.buttonText || 'View Certifications',
              certifications: Array.isArray(card.certifications) ? card.certifications : [],
              learnMoreLink: card.learnMoreLink || ''
            }));
            setProgramCards(transformedCards);
          } else {
            setProgramCards([]);
          }
        } else {
          setProgramCards([]);
          setError("Programs content is currently unavailable.");
        }
      } catch (error) {
        setProgramCards([]);
        setError("Unable to load programs right now.");
      } finally {
        setLoading(false);
      }
    };

    fetchProgramsContent();
  }, []);

  return (
    <section id="programs" className="p-8 bg-gray-100 text-center pt-24 min-[1024px]:max-[1535px]:!p-6 min-[1024px]:max-[1535px]:!pt-16">
      <h2 className="text-4xl font-bold text-custom-pink mb-4 min-[1024px]:max-[1535px]:!text-2xl min-[1024px]:max-[1535px]:!mb-3">
        {programsContent.title || "Courses Offered by JRIIT"}
      </h2>
      <span className="inline-block border-solid  border-b-4 border-gold mb-4 w-28 h-2 min-[1024px]:max-[1535px]:!mb-3 min-[1024px]:max-[1535px]:!w-24 min-[1024px]:max-[1535px]:!border-b-2"></span>
      <p className="text-lg text-gray-700 mb-8 min-[1024px]:max-[1535px]:!text-base min-[1024px]:max-[1535px]:!mb-6">
        {programsContent.description || "Explore our latest programs from the CMS."}
      </p>
      {error && <p className="text-sm text-red-500 mb-4">{error}</p>}
      <div className="flex justify-center space-x-6 min-[1024px]:max-[1535px]:!space-x-4">
        <ProgramCards programs={loading ? null : programCards} />
      </div>
      {/* <span className="block border-dotted border-l-4 border-gold mb-4 w-28 h-24 mx-auto md:ml-auto md:mr-0 lg:ml-[925px] bg-gray-100"></span> */}
    </section>
  );
};

export default ExplorePrograms;
